const API_BASE_URL = "https://fisicodaurlopass.it/api"; 
console.log("API_BASE_URL:", API_BASE_URL);

const getAuthHeaders = () => {
    const accessToken = localStorage.getItem('access_token');
    const refreshToken = localStorage.getItem('refresh_token');

    const headers = {
        'Content-Type': 'application/json',
    };

    if (accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`;
    }

    if (refreshToken) {
        headers['Refresh'] = `Bearer ${refreshToken}`;
    }

    return headers;
};

export const fetchMembers = async () => {
    try {
        const response = await fetch(`${API_BASE_URL}/users/admin/`, {
            method: 'GET',
            headers: getAuthHeaders()
        });

        const contentType = response.headers.get("content-type");
        if (!contentType || !contentType.includes("application/json")) {
            const text = await response.text();
            console.error("Received non-JSON response:", text.substring(0, 100)); // Log first 100 chars
            throw new Error(`Expected JSON but got ${contentType}. Response starts with: ${text.substring(0, 50)}...`);
        }

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error fetching members:", error);
        throw error;
    }
};

export const createMember = async (memberData) => {
    console.log("createMember called with:", memberData);
    const url = `${API_BASE_URL}/users/admin/`;
    console.log("Sending POST request to:", url);
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: getAuthHeaders(),
            body: JSON.stringify(memberData),
        });

        console.log("Response status:", response.status);
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            console.error("Response error data:", errorData);
            throw new Error(errorData.detail || `HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log("Response data:", data);
        return data;
    } catch (error) {
        console.error("Error creating member:", error);
        throw error;
    }
};

export const updateMember = async (id, memberData) => {
    console.log(`updateMember called with id: ${id}`, memberData);
    const url = `${API_BASE_URL}/users/admin/${id}`;
    console.log("Sending PUT request to:", url);
    try {
        const response = await fetch(url, {
            method: 'PUT',
            headers: getAuthHeaders(),
            body: JSON.stringify(memberData),
        });

        console.log("Response status:", response.status);
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            console.error("Response error data:", errorData);
            throw new Error(errorData.detail || `HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log("Response data:", data);
        return data;
    } catch (error) {
        console.error("Error updating member:", error);
        throw error;
    }
};

export const deleteMember = async (id) => {
    console.log(`deleteMember called with id: ${id}`);
    const url = `${API_BASE_URL}/users/admin/${id}`;
    console.log("Sending DELETE request to:", url);
    try {
        const response = await fetch(url, {
            method: 'DELETE',
            headers: getAuthHeaders()
        });

        console.log("Response status:", response.status);
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            console.error("Response error data:", errorData);
            throw new Error(errorData.detail || `HTTP error! status: ${response.status}`);
        }

        // DELETE often returns 204 No Content, so we might not get JSON
        if (response.status === 204) {
            return { success: true };
        }

        return await response.json().catch(() => ({ success: true }));
    } catch (error) {
        console.error("Error deleting member:", error);
        throw error;
    }
};

export const adminLogin = async (credentials) => {
    console.log("adminLogin called with:", credentials);
    // Based on openapi spec, the correct endpoint is /app/admin/login
    // The previous attempt at /users/admin/login failed with 405 because it matched /users/admin/{id}
    const url = `${API_BASE_URL}/app/admin/login`;
    console.log("Sending POST request to:", url);
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(credentials),
        });

        console.log("Response status:", response.status);
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            console.error("Response error data:", errorData);
            throw new Error(errorData.detail || `HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log("Response data:", data);
        return data;
    } catch (error) {
        console.error("Error logging in:", error);
        throw error;
    }
};
